import React from 'react';

import styles from './BasicInformationContainer.module.scss';

export const BasicInformationContainer: React.FC = ({ children }) => (
  <div className={styles.BasicInformationContainer}>{children}</div>
);
